import {CancelToken} from '../../../../../libs/shared/helpers/src/utilities/asyncCancelHelpers';
import {ScrollDirectionsEnum} from '../../../../../srcCommon/scroll/scrollerTypes';
import {AsyncMoreStatusesEnum} from '../../../../store/appTypes';
import {SelectedColumnSort} from '../tableColumn';

/*
 * Interfaces.
 */

export interface TableSource {
  loadAsync(cancelToken: CancelToken): Promise<void>;
  loadMoreAsync?(cancelToken: CancelToken): Promise<void>;
  updateSort?(option: SelectedColumnSort): void;
  forceReloadAsync?(cancelToken: CancelToken): Promise<void>;
}

/*
 * Helpers.
 */

export function getTableResultsMoreStatuses(isFetching: boolean, canLoadMore: boolean) {
  return {
    [ScrollDirectionsEnum.TOP]: AsyncMoreStatusesEnum.ALL_LOADED,
    [ScrollDirectionsEnum.BOTTOM]: getBottomMoreStatus(isFetching, canLoadMore),
  };
}

function getBottomMoreStatus(isFetching: boolean, canLoadMore: boolean) {
  if (isFetching) {
    return AsyncMoreStatusesEnum.LOADING;
  }
  if (canLoadMore) {
    return AsyncMoreStatusesEnum.HAS_MORE;
  }
  return AsyncMoreStatusesEnum.ALL_LOADED;
}
